import PropTypes from 'prop-types'
import MultiClamp from 'react-multi-clamp'

const AssistedSaleProductInfo = (props) => {
  const {
    name,
    id,
    url,
    assistedSale,
    offer,
    price,
    installments,
    unit
  } = props

  const renderBadges = (badges) => (
    <div className="assisted-sale-badges">
      {
        badges.map((badge, index) => (
          <span key={`${badge}-${index}`} className="assisted-sale-badge">{badge}</span>
        ))
      }
    </div>
  )

  const renderPriceTag = (offer, price, installments, unit) => {
    const { from, to } = price
    const typeClass = offer ? `type-${offer.type}` : ''

    return (
      <div className={`assisted-sale-price-tag ${typeClass}`}>
        {
          offer &&
            <div className="offer-content">
              <span className="offer-title">
                <strong>{offer.label}</strong>
              </span>
              { !Object.values(offer).includes('lowest-price') &&
                <span className="offer-value">
                  <strong>{offer.value}%</strong>
                </span>
              }
            </div>
        }
        <div className="price-tag">
          <div className="price-content">
            <span className="price">
              <strong>R$ {to.integers},{to.decimals}</strong>
            </span>
            <span className="price-unit"><strong> {unit}</strong></span>
          </div>
          <div className="installments-content">
            <span className="from-price">
              R$ {from.integers},{from.decimals} {unit}
            </span>
            { installments &&
              <span>
                <strong>{installments.amount}x</strong> de
                <strong>{installments.value}</strong> s/juros
              </span>
            }
          </div>
        </div>
      </div>
    )
  }

  const renderPriceUnavailableMessage = () => (
    <div className="price-unavailable-message-mobile">
      <p>Produto com preço indisponível</p>
    </div>
  )

  return (
    <div className="assisted-sale-product-info">
      <a className="title" href={url}>
        <MultiClamp ellipsis="..." clamp={3}>{name}</MultiClamp>
      </a>

      <div className="assisted-sale-product-code-rating">
        <span className="assisted-sale-product-code">
          Cód. {id}
        </span>
        <span
          className="product-rating bv-widget-rating"
          data-bv-show="inline_rating"
          data-bv-product-id={id}
          data-bv-redirect-url={url}
        />
      </div>

      { assistedSale.tags &&
        renderBadges(assistedSale.tags)
      }
      { price.to
        ? renderPriceTag(offer, price, installments, unit)
        : renderPriceUnavailableMessage()
      }
    </div>
  )
}

AssistedSaleProductInfo.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.number,
  unit: PropTypes.string,
  price: PropTypes.shape({
    from: PropTypes.shape({
      integers: PropTypes.string,
      decimals: PropTypes.string
    }),
    to: PropTypes.shape({
      integers: PropTypes.string,
      decimals: PropTypes.string
    })
  }),
  installments: PropTypes.shape({
    amount: PropTypes.number,
    value: PropTypes.string
  }),

  offer: PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string
  }),
  url: PropTypes.string,
  assistedSale: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.string),
    stock: PropTypes.shape({
      store: PropTypes.number,
      warehouse: PropTypes.number
    })
  })
}

export default AssistedSaleProductInfo
